<template>
  <!-- ******** Inicio Card Principal ******** -->
  <v-container text-xs-center>
    <h5 class="text-uppercase text-xs-left ml-2 mt-2 animated fadeIn delay-1s">
      Tarefas
    </h5>
    <v-card class="animated fadeIn delay-1s marginToBottom">
      <v-layout>
        <v-flex class="animated fadeIn delay-1s">
          <v-text-field
            label="Buscar"
            v-model="search"
            color="#099AB1"
            class="mt-3 mx-3"
            append-icon="search"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-left pb-2">
          <v-layout class="d-flex align-center">
            <v-flex xs8>
              <v-chip
                :disabled="!activeAtrasados"
                small
                :color="activeAtrasados ? '#f2f2f2' : 'white'"
                class="ml-3"
                @click.stop="showAtrasadas"
              >
                <v-icon small left color="#f7776e">fas fa-clock</v-icon>
                {{ getTarefasAtrasadas.length }}
              </v-chip>

              <v-chip
                :disabled="!activeEmdia"
                small
                :color="activeEmdia ? '#f2f2f2' : 'white'"
                class="ml-1"
                @click.stop="showEmdia"
              >
                <v-icon small left color="#ffc266">fas fa-clock</v-icon>
                {{ getTarefasEmDia.length }}
              </v-chip>

              <v-chip
                :disabled="!activeConcluidas"
                small
                :color="activeConcluidas ? '#f2f2f2' : 'white'"
                class="ml-1"
                @click.stop="showConcluidas"
              >
                <v-icon small left color="#95d097">check</v-icon>
                {{ getTarefasConcluidas.length }}
              </v-chip>
            </v-flex>
            <v-flex xs4>
              <v-btn color="primary" flat @click="createTask = true">
                <span class="text-lowercase">criar tarefa</span>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-divider></v-divider>

          <v-list three-line>
            <virtualList :size="96" :remain="5" ref="vlist">
              <v-list-tile v-if="filteredTasks == 0">
                <v-list-tile-content>
                  <v-list-tile-sub-title class="ml-3"
                    >Você não possui resultados</v-list-tile-sub-title
                  >
                </v-list-tile-content>
              </v-list-tile>

              <div v-for="(item, index) in filteredTasks" :key="index">
                <v-list-tile
                  :class="`mx-3 mt-1 mb-1 ${item.situacao}`"
                  class="animated fadeIn"
                >
                  <v-list-tile-content @click="showDetails(item)">
                    <v-list-tile-title
                      >{{ item.person.nome }}
                      {{ item.person.sobrenome }}</v-list-tile-title
                    >

                    <v-list-tile-sub-title>{{
                      item.description
                    }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title class="mt-1"
                      >{{ item.due | formattedDate
                      }}<v-icon
                        class="ml-1"
                        small
                        :color="item.end ? '#95d097' : '#e0e0e0'"
                        @click.stop="updateStatus(item)"
                        >check</v-icon
                      ></v-list-tile-sub-title
                    >
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider
                  v-if="index + 1 < filteredTasks.length"
                  :key="index"
                ></v-divider>
              </div>
            </virtualList>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card>
    <DetalhesTarefasModal v-model="taskDetails" />

    <CadastrarTarefa v-model="createTask" />
  </v-container>
</template>

<script>
import { APIService } from '@/resources/campanha.js';
import { mapState, mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/event-bus.js';
import pt from 'date-fns/locale/pt';
import format from 'date-fns/format';
import {
  distanceInWordsToNow,
  isFuture,
  isPast,
  endOfDay,
  addHours,
} from 'date-fns';

const ptLocale = require('date-fns/locale/pt');

const api = new APIService();

let swiper;

export default {
  filters: {
    toPercent: result => Math.floor(result * 100),
    formattedDate: item => distanceInWordsToNow(item, { addSuffix: true, locale: pt }),
  },

  methods: {
    async showDetails(task) {
      await this.$store.commit('SET_SELECTEDTASK', task);
      await this.$store.dispatch('carregarContatoTask');
      this.taskDetails = true;
    },
    emitSnackBar() {
      const snackBar = {};
      snackBar.text = 'Status alterado com sucesso!';
      snackBar.value = true;
      EventBus.$emit('activeSnackBar', snackBar);
    },
    async updateStatus(item) {
      if (item.end) {
        item.end = null;
        api.updateTask(item);
        this.emitSnackBar();
      } else {
        item.end = new Date();
        api.updateTask(item);
        this.emitSnackBar();
      }
    },
    isEmDia(value) {
      value.situacao = 'EMDIA';
      return !value.end && isFuture(endOfDay(addHours(value.due, 3)));
    },
    isAtrasado(value) {
      value.situacao = 'ATRASADO';
      return !value.end && isPast(endOfDay(addHours(value.due, 3)));
    },
    isConcluido(value) {
      value.situacao = 'CONCLUIDO';
      return value.end;
    },
    showConcluidas() {
      this.activeConcluidas = !this.activeConcluidas;
      if (this.activeConcluidas) {
        this.$refs.vlist.forceRender();
      } else {
        this.$refs.vlist.forceRender();
      }
    },
    showAtrasadas() {
      this.activeAtrasados = !this.activeAtrasados;
      this.$nextTick(() => {
        if (this.activeAtrasados) {
          this.$refs.vlist.forceRender();
        } else {
          this.$refs.vlist.forceRender();
        }
      });
    },
    showEmdia() {
      this.activeEmdia = !this.activeEmdia;
      this.$nextTick(() => {
        if (this.activeEmdia) {
          this.$refs.vlist.forceRender();
        } else {
          this.$refs.vlist.forceRender();
        }
      });
    },
  },
  computed: {
    ...mapState(['tasks']),
    ...mapGetters([
      'getTarefasConcluidas',
      'getTarefasEmDia',
      'getTarefasAtrasadas',
    ]),

    filteredTasks() {
      return this.$store.state.tasks.filter(
        el => ((this.activeEmdia && this.isEmDia(el))
            || (this.activeAtrasados && this.isAtrasado(el))
            || (this.activeConcluidas && this.isConcluido(el)))
          && el.person.nome.toLowerCase().match(this.search.toLowerCase()),
      );
    },
  },

  data() {
    return {
      menu: false,
      message: false,
      hints: true,
      createTask: false,
      taskDetails: false,
      activeAtrasados: true,
      activeEmdia: true,
      activeConcluidas: false,
      search: '',
    };
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: none;
  border-radius: 10px;
}

.theme--light.v-sheet {
  border: 1px solid #e0e0e0;
}

.v-expansion-panel__header {
  padding-bottom: 12px !important;
}
.EMDIA {
  border-left: 3px solid #ffc266 !important;
}
.ATRASADO {
  border-left: 3px solid #f7776e !important;
}
.CONCLUIDO {
  border-left: 3px solid #95d097 !important;
}
</style>

<style>
.marginToBottom {
  margin-bottom: 175px;
}
</style>
